<template>
  <section class="mega-services-section bg-gradient-to-br from-green-400 to-green-500 py-20 relative overflow-hidden">
    <!-- Decorative elements -->
    <div class="absolute inset-0 opacity-10">
      <div class="absolute top-20 left-1/4 w-60 h-60 bg-green-500 rounded-full filter blur-3xl"></div>
      <div class="absolute bottom-20 right-1/4 w-80 h-80 bg-green-400 rounded-full filter blur-3xl"></div>
    </div>
    
    <div class="container mx-auto px-4 relative z-10">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <h2 class="mega-section-title text-white">
          {{ t("services.servicesTitle") }}
        </h2>
        <!-- <p class="text-blue-200 mt-4 max-w-2xl mx-auto text-lg">
          {{ t("services.servicesSubtitle") }}
        </p> -->
      </div>

      <!-- Services Grid -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <TransitionGroup name="mega-service-list" tag="div" class="contents" appear>
          <div
            v-for="(service, index) in services"
            :key="service.id"
            class="mega-service-card bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-white/20"
            :style="{ animationDelay: `${index * 0.1}s` }"
          >
            <div class="flex flex-col items-center text-center h-full">
              <!-- Icon Container -->
              <div class="mega-service-icon bg-gradient-to-br from-green-600 to-green-400 text-white rounded-2xl p-5 mb-6 shadow-lg">
                <component :is="service.icon" class="w-10 h-10" />
              </div>
              
              <!-- Service Content -->
              <div class="flex-1 flex flex-col">
                <h3 class="text-2xl font-bold mb-4 text-gray-800">
                  {{ t(`services.${service.name}`) }}
                </h3>
                <p class="text-gray-600 mb-6 flex-1">
                  {{ t(`services.${service.description}`) }}
                </p>
                <!-- <RouterLink 
                  :to="service.link" 
                  class="mt-auto inline-flex items-center justify-center text-blue-600 hover:text-blue-800 font-medium transition-colors duration-300"
                >
                  {{ t("services.learnMore") }}
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </RouterLink> -->
              </div>
            </div>
          </div>
        </TransitionGroup>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { Wrench, Settings, Cpu, ClipboardCheck } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const services = ref([
  {
    id: 1,
    name: "production",
    description: "productionDesc",
    icon: Settings,
    link: "/services/production"
  },
  {
    id: 2,
    name: "maintenance",
    description: "maintenanceDesc",
    icon: Wrench,
    link: "/services/maintenance"
  },
  {
    id: 3,
    name: "commissioning",
    description: "commissioningDesc",
    icon: ClipboardCheck,
    link: "/services/commissioning"
  }
  // {
  //   id: 4,
  //   name: "consulting",
  //   description: "consultingDesc",
  //   icon: Cpu,
  //   link: "/services/consulting"
  // }
]);
</script>

<style scoped>
/* .mega-services-section {
  background-image: radial-gradient(circle at 20% 30%, rgba(0, 119, 255, 0.15) 0%, transparent 30%);
} */

.mega-section-title {
  font-size: 2.8rem;
  position: relative;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.mega-section-title::after {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #FFD700, #FFFFFF);
  border-radius: 2px;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.5);
}

.mega-service-card {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.mega-service-card:hover {
  box-shadow: 0 25px 50px -12px rgba(0, 119, 255, 0.25);
}

.mega-service-icon {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.mega-service-card:hover .mega-service-icon {
  transform: rotate(5deg) scale(1.1);
  box-shadow: 0 10px 25px rgba(0, 119, 255, 0.3);
}

/* Animation for service items */
.mega-service-list-move,
.mega-service-list-enter-active,
.mega-service-list-leave-active {
  transition: all 0.8s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.mega-service-list-enter-from,
.mega-service-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.mega-service-list-leave-active {
  position: absolute;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .mega-section-title {
    font-size: 2.4rem;
  }
}

@media (max-width: 768px) {
  .mega-section-title {
    font-size: 2rem;
  }
  
  .mega-services-section {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
}

@media (max-width: 640px) {
  .mega-section-title {
    font-size: 1.8rem;
  }
  
  .mega-section-title::after {
    width: 60px;
    height: 3px;
    bottom: -8px;
  }
  
  .mega-service-card {
    padding: 1.5rem;
  }
  
  .mega-service-icon {
    padding: 3rem;
  }
}
</style>